import type { IconDef } from '../types';

export const plus: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M22 11H13V2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V11H2C1.45 11 1 11.45 1 12C1 12.55 1.45 13 2 13H11V22C11 22.55 11.45 23 12 23C12.55 23 13 22.55 13 22V13H22C22.55 13 23 12.55 23 12C23 11.45 22.55 11 22 11Z',
    },
  ],
};
